module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-HeavyItalic.1c6addd.eot";